/* External */
import { memo } from 'react';

/* Ott-common */
import { usePlayerTime } from '@dtvgo/player-context';

/* Components */
import CurrentTime from './CurrentTime';

function VodCurrentTime() {
  return <CurrentTime progress={usePlayerTime()} />;
}

export default memo(VodCurrentTime);
